import { UrbanNetworkLoaderV2 } from '../../layouts/components/UrbanNetworkLoaderV2';
import type { SceneMode } from './ProjectTerritorialScene';

export interface ShellHeaderProps {
  userName: string;
  projectName: string | null;
  sceneMode: SceneMode;
  onSceneModeChange: (mode: SceneMode) => void;
}

export function ShellHeader({
  userName,
  projectName,
  sceneMode,
  onSceneModeChange,
}: ShellHeaderProps): JSX.Element {
  return (
    <header className="ts-header">
      <div className="ts-header-brand">
        <UrbanNetworkLoaderV2 size="xs" className="ts-logo" />
        <span className="ts-header-wordmark">WESTEER</span>
      </div>
      <div className="ts-header-meta">
        {projectName && (
          <span className="ts-project-badge">
            <span className="ts-project-dot" aria-hidden="true" />
            {projectName}
          </span>
        )}
        {userName && <span className="ts-user-name">{userName}</span>}
        <div className="ts-scene-selector">
          {(['dark', 'light', 'topographic', 'satellite'] as SceneMode[]).map(mode => (
            <button
              key={mode}
              className={`ts-theme-btn${sceneMode === mode ? ' ts-theme-btn--active' : ''}`}
              type="button"
              onClick={() => onSceneModeChange(mode)}
              aria-label={`Modo ${mode}`}
            >
              {mode.charAt(0).toUpperCase() + mode.slice(1)}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
